import type { Locale } from './zh_CN';

const fullYear = new Date().getFullYear();
export const en: Locale = {
  lang: 'en',
  layout: {
    home: 'Home',
    header: {
      profile: 'Profile',
      download: 'Download',
      password: 'Password',
      logout: 'SignOut'
    },
    footer: {
      website: 'Website',
      document: 'Document',
      authorization: 'Authorization',
      ipc: '蜀ICP备17025563号-7',
      copyright: `© 2017-${fullYear} Chengdu Lunzhidao Technology Co., Ltd `
    },
    logout: {
      title: 'Confirm',
      message: 'Are you sure you want to log out?'
    },
    tabs: {
      reload: 'Refresh',
      close: 'Close',
      closeLeft: 'Close Left',
      closeRight: 'Close Right',
      closeOther: 'Close Other',
      closeAll: 'Close All',
      fullscreen: 'Fullscreen',
      fullscreenExit: 'Fullscreen'
    },
    setting: {
      title: 'Theme Setting',
      sideStyles: {
        dark: 'Dark Sidebar',
        light: 'Light Sidebar'
      },
      headStyles: {
        light: 'Light Header',
        dark: 'Dark Header',
        primary: 'Primary Header'
      },
      layoutStyles: {
        side: 'Side Menu Layout',
        top: 'Top Menu Layout',
        mix: 'Mix Menu Layout'
      },
      colors: {
        default: 'Daybreak Blue',
        dust: 'Dust Blue',
        sunset: 'Sunset Orange',
        volcano: 'Volcano',
        purple: 'Golden Purple',
        green: 'Polar Green',
        geekblue: 'Geek Blue'
      },
      darkMode: 'Dark Mode',
      roundedTheme: 'Rounded Theme',
      layout: 'Navigation Mode',
      sidebarLayout: 'Sidebar Double Menu',
      fluid: 'Full Body Width',
      other: 'Other Setting',
      more: 'More Setting',
      tab: 'Tab Setting',
      fixedHeader: 'Fixed Header',
      fixedSidebar: 'Fixed Sidebar',
      fixedBody: 'Scrollbar In Content',
      logoInHeader: 'Logo In Header',
      colorfulIcon: 'Colorful Icon',
      uniqueOpened: 'Menu Unique Open',
      responsive: 'Responsive',
      weakMode: 'Weak Mode',
      showTabs: 'Show Tabs',
      fixedHome: 'Fixed Home Tab',
      tabInHeader: 'Tab In Header',
      tabStyle: 'Tab Style',
      tabStyles: {
        default: 'Default',
        dot: 'Dot',
        tag: 'Tag',
        card: 'Card'
      },
      menuItemTrigger: 'Menu Division',
      transitionName: 'Transition',
      transitions: {
        slideRight: 'Slide Right',
        slideBottom: 'Slide Bottom',
        zoomIn: 'Zoom In',
        zoomOut: 'Zoom Out',
        fade: 'Fade'
      },
      reset: 'Reset'
    }
  },
  login: {
    title: 'User Login',
    username: 'please input username',
    password: 'please input password',
    code: 'please input code',
    remember: 'remember',
    login: 'Login',
    passwordType: 'Password',
    qrcodeType: 'QR Code',
    refreshQrcode: 'Refresh'
  },
  list: {
    // 基础列表
    basic: {
      table: {
        avatar: 'Avatar',
        username: 'Username',
        nickname: 'Nickname',
        organizationName: 'Organization',
        phone: 'Phone',
        email: 'Email',
        roles: 'Roles',
        sexName: 'Sex',
        createTime: 'CreateTime',
        status: 'Status',
        action: 'Action'
      }
    }
  },
  global: {
    btns: {
      add: 'Add',
      export: 'Export',
      import: 'Import',
      edit: 'Edit',
      remove: 'Remove',
      search: 'Search',
      reset: 'Reset',
      submit: 'Submit',
      submitImport: 'Submit Import',
      submitContinue: 'Submit Continue',
      confirm: 'Confirm',
      revoke: 'Revoke',
      cancel: 'Cancel',
      close: 'Close',
      upload: 'Upload',
      download: 'Download',
      homePage: 'Home Page',
      signIn: 'Sign In',
      signOut: 'Sign Out',
      enabled: 'Enabled',
      disabled: 'Disabled',
      locked: 'Locked',
      resetPassword: 'Reset Password',
      notification: 'Notification',
      batchResetPassword: 'Batch Reset Password',
      copy: 'Copy',
      assignPermissions: 'Assign Permissions',
      configuration: 'Configuration',
      collapseAll: 'Collapse All',
      expandAll: 'Expand All',
      view: 'View',
      setAsPublished: 'Set as Published',
      setAsUnpublished: 'Set as Unpublished',
      assignAdvisor: 'Assign Advisor',
      confirmSelection: 'Confirm Selection',
      unpairAdvisorStudent: 'Unpair the Advisor-Student Pair',
      batchAdd: 'Batch Add'
    },
    export: {
      select: {
        range: 'Export Range',
        fields: 'Select Export Fields'
      }
    },
    placeholder: {
      select: 'please select',
      input: 'please enter',
      selectRange: 'please select range',
      university: 'university',
      college: 'college',
      department: 'department',
      major: 'major',
      teaching: 'teaching and research office',
      grade: 'grade',
      class: 'class',
      graduation: 'graduation year',
      studentType: 'student type',
      degreeType: 'degree type',
      thesisType: 'thesis type',
      thesisTitle: 'thesis title',
      studentPhone: 'student phone',
      studentEmail: 'student email',
      studentName: 'student name',
      studentId: 'student account',
      supervisorName: 'supervisor name',
      supervisorId: 'supervisor account'
    },
    tips: {
      processing: 'Processing...',
      lodding: 'Loading...',
      err404: 'Sorry, the page you are trying to access does not exist.',
      tokenExpired: 'The sign in session has expired, please sign in again',
      required: 'Cannot be empty, please enter',
      remove: 'Data cannot be recovered after deletion. Do you want to proceed?'
    },
    /** 任务状态 */
    task: {
      status: {
        pending: 'Pending',
        processing: 'Processing',
        completed: 'Completed'
      }
    }
  }
};
